"use client";
import { jsx } from "react/jsx-runtime";
import { StyledLink } from "./styles.js";
import { COMPONENT_NAME } from "./types.js";
import { TextView } from "./view.text.js";
import { getDataTestId } from "../../Util/index.js";
const AnnouncementBanner = ({
  color = "blue",
  text,
  href,
  uniqueId,
  target = "_self"
}) => {
  if (href) {
    return /* @__PURE__ */ jsx(StyledLink, { href, underline: "none", target, children: /* @__PURE__ */ jsx(
      TextView,
      {
        color,
        text,
        linksAsText: true,
        uniqueId: getDataTestId(COMPONENT_NAME, uniqueId)
      }
    ) });
  }
  return /* @__PURE__ */ jsx(
    TextView,
    {
      text,
      color,
      linksAsText: false,
      uniqueId: getDataTestId(COMPONENT_NAME, uniqueId)
    }
  );
};
AnnouncementBanner.displayName = COMPONENT_NAME;
export {
  AnnouncementBanner
};
